module.exports = __webpack_public_path__ + "./fonts/impact-webfont.d83d0712d642565600f1d8be3fa47e73.ttf";